import { RedEventStore } from '@nostr/gadgets/redstore'
import RedStoreWorker from '@nostr/gadgets/redstore/redstore-worker?worker'
import { setReplaceableStore } from '@nostr/gadgets/global'

function createStore(): RedEventStore {
  return new RedEventStore(
    new RedStoreWorker(),
    '@gadgets-redstore',
    'https://cdn.jsdelivr.net/gh/nbd-wtf/nostr-gadgets@v0.2.8-redstorewasm/gadgets_redstore_bg.wasm'
  )
}

export let store: RedEventStore = createStore()

export async function resetStore(): Promise<void> {
  try {
    await store.close()
  } catch (error) {
    console.warn('failed to close store during reset:', error)
  }
  try {
    await store.delete()
  } catch (error) {
    console.warn('failed to delete store during reset:', error)
  }

  const dummy = {
    queryEvents: async () => [],
    saveEvent: async () => false,
    loadReplaceables: async (specs: any[]) =>
      specs.map(([kind]: [number]) =>
        kind >= 30000 && kind < 40000 ? [undefined, []] : [undefined, undefined]
      ),
    deleteReplaceable: async () => {},
    deleteEvents: async () => {},
    getOutboxBounds: async () => ({}),
    setOutboxBound: async () => {},
    close: async () => {},
    delete: async () => {},
    init: async () => false
  }

  store = dummy as unknown as RedEventStore
  setReplaceableStore(dummy as any)
  if ((window as any).hallway) {
    ;(window as any).hallway.store = dummy
  }

  const newStore = createStore()
  store = newStore
  setReplaceableStore(newStore)
  if ((window as any).hallway) {
    ;(window as any).hallway.store = newStore
  }
}
